// TODO: jjw: put field keys in enums & map to display values

export interface AmortizationLoanInfo {
  starting_loan_amount: number;
  rate: number;
  term_in_months: number;
  monthly_p_and_i: number;
}

export interface AmortizationEscrowInfo {
  starting_balance: number;
  monthly_tax_payment: number;
  monthly_insurance_payment: number;
}

export interface AmortizationLoanDetails {
  starting_principal: number;
  expected_payment: number;
  expected_interest_payment: number;
  actual_payment: number;
  payment_delta: number;
  additional_payment: number;
  interest_payment: number;
  principal_payment: number;
  remaining_principal: number;
}

export interface AmortizationEscrowDetails {
  escrow_account_balance: number;
  escrow_payment: number;
  tax_payment: number;
  insurance_payment: number;
  mortgage_insurance_payment: number;
  escrow_disbursement: number;
}

export interface AmortizationScheduleRow {
  month_number: number;
  month: string; // CivilDate ("YYYY-MM-01")
  actual_total_payment: number; // NOTE: jjw: unused; same as loan_details.actual_payment
  loan_details: AmortizationLoanDetails;
  escrow_details: AmortizationEscrowDetails;
}

/** For taking AmortizationScheduleRows and parsing number values from strings. */
const parseAmortizationScheduleRow = (obj: any): AmortizationScheduleRow => {
  const { month_number, actual_total_payment, loan_details, escrow_details } = obj;

  return {
    ...obj,
    month_number: Number(month_number),
    actual_total_payment: Number(actual_total_payment),
    loan_details: {
      ...loan_details,
      starting_principal: Number(loan_details.starting_principal),
      expected_payment: Number(loan_details.expected_payment),
      expected_interest_payment: Number(loan_details.expected_interest_payment),
      actual_payment: Number(loan_details.actual_payment),
      payment_delta: Number(loan_details.payment_delta),
      additional_payment: Number(loan_details.additional_payment),
      interest_payment: Number(loan_details.interest_payment),
      principal_payment: Number(loan_details.principal_payment),
      remaining_principal: Number(loan_details.remaining_principal),
    },
    escrow_details: {
      ...escrow_details,
      escrow_account_balance: Number(escrow_details.escrow_account_balance),
      escrow_payment: Number(escrow_details.escrow_payment),
      tax_payment: Number(escrow_details.tax_payment),
      insurance_payment: Number(escrow_details.insurance_payment),
      mortgage_insurance_payment: Number(escrow_details.mortgage_insurance_payment),
      escrow_disbursement: Number(escrow_details.escrow_disbursement),
    },
  };
};

export interface Amortization {
  loan_info: AmortizationLoanInfo;
  escrow_info: AmortizationEscrowInfo;
  schedule: AmortizationScheduleRow[];
}

/** For taking Amortizations emitted by the API and parsing number values from strings. */
export const parseAmortizationResponse = (obj: any): Amortization => {
  const { loan_info, escrow_info, schedule } = obj;

  return {
    ...obj,
    loan_info: {
      ...loan_info,
      starting_loan_amount: Number(loan_info.starting_loan_amount),
      rate: Number(loan_info.rate),
      term_in_months: Number(loan_info.term_in_months),
      monthly_p_and_i: Number(loan_info.monthly_p_and_i),
    },
    escrow_info: {
      ...escrow_info,
      starting_balance: Number(escrow_info.starting_balance),
      monthly_tax_payment: Number(escrow_info.monthly_tax_payment),
      monthly_insurance_payment: Number(escrow_info.monthly_insurance_payment),
    },
    schedule: schedule.map(parseAmortizationScheduleRow),
  };
};
